import React from 'react'
// components
import ReportAPI from 'containers/Report/layers/API/index'
import Report from 'components/PageComponents/DataHub/Report/index'

const ReportContainer: React.FC = () => {
  return (
    <ReportAPI>
      <Report />
    </ReportAPI>
  )
}

export default ReportContainer
